import SuarteName from '@/shared-components/icons/components/public/SuarteName';

import OnBoardingSlider from './OnBoardingSlider';

import './styles/OnBoardingLayout.scss';

export default function OnBoardingLayout({ user_type }) {

  return (
    <>
      <div className="onboarding-layout__container">
        <div className="onboarding-layout__card">
          <SuarteName className="onboarding-layout__suarte-name"/>
          <OnBoardingSlider user_type={user_type} />
        </div>
      </div>
    </>
  );
}
